import { FC } from 'react'
import { Row, Col, Text, Breadcrumb, Content } from '@/client/components'
import * as S from './styles'
import { IInfos } from '../types'

export const Infos: FC<IInfos> = ({ content: data }) => {
  const { breadcrumb, title, content } = data
  return (
    <S.Featured>
      <Row>
        <Col>
          <Breadcrumb pages={breadcrumb} />
        </Col>
      </Row>
      <Row>
        <Col>
          <S.MainFeatured>
            <Text as='h1' size='xxlg' family='heading' weight='bold' margin='0 0 2.5rem' itemProp='name'>
              {title}
            </Text>
          </S.MainFeatured>

          {content && <Content content={content} />}
        </Col>
      </Row>
    </S.Featured>
  )
}
